import React from "react";
import { motion } from "framer-motion";
import { GALLERY } from "@/data/site";

export default function Gallery() {
  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="bg-[#F2EFE9] py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="overline">The viewing room</p>
            <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-4">
              Selected
              <br />
              <span className="italic font-light">portfolio.</span>
            </h2>
          </div>
          <p className="text-[#4A4A4A] max-w-sm leading-relaxed">
            A curated sample of weddings, maternity, events and portraits —
            chosen for their light and their honesty.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 auto-rows-[180px] md:auto-rows-[260px] gap-3 md:gap-4">
          {GALLERY.map((item, i) => (
            <motion.figure
              key={i}
              data-testid={`gallery-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
              className={`gallery-item relative overflow-hidden group bg-[#1A1A1A] ${item.span}`}
            >
              <img
                src={item.src}
                alt={`${item.category} portfolio`}
                className={`w-full h-full ${
                  item.fit === "cover" ? "object-cover" : "object-contain"
                }`}
                style={item.focus ? { objectPosition: item.focus } : undefined}
                loading="lazy"
              />
              <figcaption className="absolute inset-0 flex items-end p-5 bg-gradient-to-t from-black/70 via-black/0 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <span className="overline text-[#E6D3A3]">
                  {item.category}
                </span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
